import {
  SET_DATE,
} from './mutations.type';

export default {
  [SET_DATE](state, dateSelection) {
    state.dateSelection = dateSelection;
  },
};
